const UrlReducer = (state = {mainSiteUrl: '', btisApiUrl: ''}, action) => {
    switch (action.type) {
        case 'url/UPDATE_SITE':
            return {...state, ...action.payload};
        case 'SHOW_LOADER':
            return {
                ...state,
                loading:true
            };

        case 'HIDE_LOADER':
            return {
                ...state,
                loading:false
            };
        default:
            return state;
    }
};

export default UrlReducer;